import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// IMPORT GUARD FILES

import { AuthGuard } from './../../auth.guard';
import { ModuleGuard } from './../../permission.guard';
import { Role } from './../../_models/role';
import { Permission } from './../../_models/permission';


// IMPORT JOB MODULE COMPONENTS

import { MainJobComponent } from './main-job.component';
import { JobsComponent } from './../jobs.component';
import { AddJobModalComponent } from './../add-job-modal/add-job-modal.component';
import { EditJobModalComponent } from './../edit-job-modal/edit-job-modal.component';
import { EditMpJobComponent } from './../edit-mp-job/edit-mp-job.component';
import { JobComponent } from './../job/job.component';
import { MpjobComponent } from './../mpjob/mpjob.component';
import { AddMpJobComponent } from './../add-mp-job/add-mp-job.component';


const routes: Routes = [
  {
    path: '',
    component: MainJobComponent,
    children: [
      {
        path: 'list',
        component: JobsComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.IQA], permission: [Permission.TrainingJob, Permission.MpJob] }
      },
      {
        path: 'add-job',
        component: AddJobModalComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.IQA], permission: [Permission.TrainingJob] }
      },
      {
        path: 'edit-job/:id',
        component: EditJobModalComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.IQA], permission: [Permission.TrainingJob] }
      },
      {
        path: 'edit-mpjob/:id',
        component: EditMpJobComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.IQA], permission: [Permission.MpJob] }
      },
      {
        path: 'view/:jobid',
        component: JobComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.IQA], permission: [Permission.TrainingJob] }
      },
      {
        path: 'mpjob/:jobid',
        component: MpjobComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Admin, Role.Trainer, Role.Client, Role.Mp, Role.IQA], permission: [Permission.MpJob] }
      },
      {
        	path: 'addmpjob',
        	component: AddMpJobComponent
        },
      {
        path: '',
        component: MainJobComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainJobRoutingModule { }
